import {Service} from "../Axios/Service";
import {NewService} from "../Axios/Service";
import qs from "qs";
import store from "../../store";

const PROFILE = {
    user: "VUE_APP_USER_PREFIX",
    oauth: "VUE_APP_OAURH_PREFIX",
    resource: "VUE_APP_RESOURCE_PREFIX",
    inquiry: "VUE_APP_INQUIRY_PREFIX",
    apply: "VUE_APP_APPLY_PREFIX",
    plan: "VUE_APP_PLAN_PREFIX",
};

function getType(apiType) {
    return process.env[PROFILE[apiType]];
}

class Api {
    constructor(ApiType) {
        this.ApiType = ApiType;
    }

    // 酒店详情产品接口
    productDetail(data) {
        return NewService({
            url: `/customizerWeb/v1/resource/productDetail`,
            method: "post",
            data,
        });
    }
    getTagetId(messageId) {
        return NewService({
            url: `customizerWeb/v1/userMessage/getTagetId?messageId=${messageId}`,
            method: "post",
        });
    }
    // 订单详情接口
    seeOrderDetail(childrenId) {
        return NewService({
            url: `customizerWeb/v1/order/seeOrderDetail?childrenId=${childrenId}`,
            method: "get"
        });
    }

    // 立即询价接口
    orderInquiryAdd1(data) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/orderInquiryAdd`,
            method: "post",
            data
        });
    }

    // 确认取消接口
    orderPartHasBeenPaidAndCancelled(id, data) {
        return NewService({
            url: `/customizerWeb/v1/order/orderPartHasBeenPaidAndCancelled/${id}`,
            method: "post",
            data
        });
    }

    // 获取取消库存数量接口
    seeOrderDetailCancelNumber(data) {
        return NewService({
            url: `/supplierWeb/v1/order/seeOrderDetailCancelNumber?stockId=${data.stockId}&useDate=${data.useDate}&childrenId=${data.childrenId}`,
            method: "get"
        });
    }

    //获取酒店模版详情
    getHotelTemplateDetail(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/stock/getSpecialNote`,
            method: "post",
            data: {id}
        });
    }

    //酒店模版保存
    addHotelTemplate(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/stock/saveSpecialNote`,
            method: "post",
            data,
        });
    }

    //酒店模版列表
    hotelTemplateList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/stock/specialNoteList`,
            method: "post",
            data,
        });
    }

    //聊天消息列表
    getChatList(data) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/chatDzsList`,
            method: "post",
            data,
        });
    }
   //聊天消息列表
    planList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/plan/planList`,
            method: "post",
            data,
        });
    }
    //发送聊天消息
    sendChat(data) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/sendDzsMessage`,
            method: "post",
            data,
        });
    }

    userToInquiry(data) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/userToInquiry`,
            method: "post",
            data,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }
    //用户心声列表
    postList(data) {
        return NewService({
            url: `/customizerWeb/v1/post/postList`,
            method: "post",
            data,
        });
    }

    //查看用户信息
    viewUserInformation(data) {
        return NewService({
            url: `/customizerWeb/v1/user/getUserInfo`,
            method: "post",
            data,
        });
    }

    //用户心声回复
    createPostComment(data) {
        return NewService({
            url: `/customizerWeb/v1/post/createPostComment`,
            method: "post",
            data,
        });
    }

    //修改订单
    updateBudgetStockCompany(data) {
        return NewService({
            url: `/customizerWeb/v1/budget/updateBudgetStockCompany`,
            method: "post",
            data,
        });
    }


    //政策详情
    policyDetails(id, type = 1) {
        return NewService({
            url: `/customizerWeb/v1/stock/lookDetail?type=${type}&id=${id}`,
            method: "post",
        });
    }

    selectPlanInvoice(planId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/invoicing/selectPlanInvoice?planId=${planId}`,
            method: "post",
        });
    }

    //发票关联列表
    queryDetailLink(invoicingDetailId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/queryDetailLink?invoicingDetailId=${invoicingDetailId}`,
            method: "get",
        });
    }

    //删除发票详情关联
    deleteDetailLink(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/delDetailLinkByIds`,
            method: "post",
            data,
        });
    }

    //重新关联发票详情
    reLinkInvoice(data, invoicingDetailId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/reAssociateDetailLink?invoicingDetailId=${invoicingDetailId} `,
            method: "post",
            data,
        });
    }

    //发票撤回
    withdrawInvoice(invoiceId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/invoiceWithdrawal?invoiceId=${invoiceId}`,
            method: "get",
        });
    }

    updateByIdToFpNumber(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/updateByIdToFpNumber`,
            method: "post",
            data: data,
        });
    }

    //询单设置
    inquirySet(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/informationInquiry/inquirySet`,
            method: "post",
            data,
        });
    }

    //询单设置回显
    inquirySetFind(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/informationInquiry/inquirySetFind`,
            method: "post",
            data,
        });
    }

    //订单专属详情
    exclusiveDetail(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/stock/detail`,
            method: "post",
            data,
        });
    }

    //查询会议
    siteDetail(rid) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/resource/siteDetail?rid=${rid}`,
            method: "post",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    customStockDetail(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/custom/customStockDetail`,
            method: "post",
            data,
        });
    }

    //订单询单新增(订单确认后变更)
    orderInquiryAdd(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/projectInquiry/orderInquiryAdd`,
            method: "post",
            data: data,
        });
    }

    //预算产品列表
    budgetProductList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/categorySon/list`,
            method: "post",
            data: data,
        });
    }

    //基础产品列表
    resourceProductList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/resourceProduct/list`,
            method: "post",
            data: data,
        });
    }

    //发票列表接口
    queryInvoice(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/pageList`,
            method: "post",
            data: data,
        });
    }

    //查询公司信息
    queryCompanyInfo() {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/queryCompanyInfo`,
            method: "post",
            data: {},
        });
    }

    //收货人地址保存
    addShippingAddress(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/userAddress/save`,
            method: "post",
            data: data,
        });
    }

    //收货人地址当个查询
    queryOneAddShippingAddress(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/userAddress/queryOne`,
            method: "post",
            data: qs.stringify({id: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //根据该公司下所有收货人的信息
    queryAllAddress() {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/userAddress/queryAll`,
            method: "post",
            data: {},
        });
    }

    //新增发票信息
    addInvoice(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/invoicing/save`,
            method: "post",
            data: data,
        });
    }

    //获取客人房间列表
    getRoomList(orderChildrenId) {
        return NewService({
            url: `/customizerWeb/v1/order/getRoomList?childrenId=${orderChildrenId}`,
            method: "get"
        });
    }

    //保存客人名单
    saveRoomCustom(data) {
        return NewService({
            url: `/customizerWeb/v1/order/saveRoomCustom`,
            method: "post",
            data
        });
    }

    //评价列表
    evaluationList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/evaluate/evaluationList`,
            method: "post",
            data: data,
        });
    }

    //点评
    evaluate(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/evaluate/save`,
            method: "post",
            data: data,
        });
    }

    //默认好评
    defaultPositiveReviews(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/evaluate/defaultPositiveReviews`,
            method: "post",
            data: qs.stringify({childrenId: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //查看评价
    viewComments(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/evaluate/viewComments`,
            method: "post",
            data: qs.stringify({childrenId: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    /**
     * 文件删除
     * @param {*} uid
     */
    delFile(uid) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/userUpload/delFile`,
            method: "post",
            data: qs.stringify({id: uid}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    uploadSingle(formData) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/userUpload/uploadSingle`,
            method: "post",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    uploadResourceSingle(formData) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/api/resourceUpload/uploadSingle`,
            method: "post",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    /**
     * 通过父级ID的集合查询图片
     * @param picIdArr
     * @returns {*}
     */
    queryPicByParentIds(picIdArr) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/userUpload/queryPicByParentIds`,
            method: "post",
            data: picIdArr,
        });
    }

    spotAddList(formData) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/resource/spotAddList`,
            method: "post",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    //公司信息查询
    selectCompanyInfo(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/selectCompanyInfo`,
            method: "post",
            data: obj,
        });
    }

    //机构店铺维护页面保存
    updateCompanyInfo(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/updateCompanyInfo`,
            method: "post",
            data: obj,
        });
    }

    //个人信息查询
    selectUserInfo(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/selectUserInfo`,
            method: "post",
            data: obj,
        });
    }

    //个人信息页面保存
    updateUserInfo(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/updateUserInfo`,
            method: "post",
            data: obj,
        });
    }

    //获取验证码
    sendRegisterCode(data) {
        console.log(data, "看坎坎坷坷");
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/sms/sendRegisterCode`,
            method: "post",
            data: qs.stringify({phoneNumber: data}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    sendPayCode(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/sms/sendPayCode`,
            method: "post",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    resourceInfo(resourceInfoRequest) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/resourceInfo`,
            method: "post",
            data: resourceInfoRequest,
        });
    }

    //修改密码
    updatePassword(_data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/updatePassword`,
            method: "post",
            data: _data,
        });
    }

    //前台用户列表
    userList(_data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/list`,
            method: "post",
            data: _data,
        });
    }

    //新增用户
    userAdd(_data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/add`,
            method: "post",
            data: _data,
        });
    }

    //更新用户列表
    updateUserList(_data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/updateUserList`,
            method: "post",
            data: _data,
        });
    }

    //修改业务审核ID
    updateStatusByPid(pid, status) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/applyButton/updateStatusByPid`,
            method: "post",
            data: qs.stringify({pid: pid, status: status}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    //定制师接单区域删除
    customizerAreaDel(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/supplierArea/del`,
            method: "post",
            data: qs.stringify({id: id}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    //定制师入驻
    customizerSettleIn(_data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/settle/customizerSettleIn`,
            method: "post",
            data: _data,
        });
    }

    //获取定制师入驻详细信息
    getCustomizerInfo(companyId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/settle/getCustomizerInfo`,
            method: "post",
            data: qs.stringify({companyId: companyId}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    //免密登录
    exchangeForToken(code) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/user/exchangeForToken`,
            method: "post",
            data: qs.stringify({code: code}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    //用户登录
    userLogin(datas) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/user/loginC`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //用户登录
    userLoginNew(datas) {
        return NewService({
            url: `/customizerWeb/v1/user/login`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //获取询单操作日志
    getInquiryOperationLog(obj) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/inquiryLog`,
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //用户沟通列表
    userSendMessageList(data) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/userSendMessageList`,
            method: "post",
            data
        })
    }


    getMessageNumber(messageType = '') {
        return NewService({
            url: `/customizerWeb/v1/userMessage/unreadMessageNumber?messageType=${messageType}`,
            method: "post",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    inquiryDetail(datas) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/inquiryDetail`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    canclePrice(datas) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/canclePrice`,
            method: "post",
            data: datas,
        });
    }

    sendPrice(datas) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/sendPrice`,
            method: "post",
            data: datas,
        });
    }

    readMessage(datas) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/readMessage`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    deleteMessage(datas) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/deleteMessage`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    agreeInquiry(datas) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/agreeInquiry`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    readAllMessage(datas) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/readAllMessage`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    getInquiryPlan(datas) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/getInquiryPlanId`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    projectInquiryStockListNew(obj) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/inquiryStockList`,
            method: "post",
            data: obj,
        });
    }

    budgetList(obj) {
        return NewService({
            url: `/customizerWeb/v1/budget/list`,
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    getMessageList(datas) {
        return NewService({
            url: `/customizerWeb/v1/userMessage/list`,
            method: "post",
            data: datas,
        });
    }

    budgetAdd(datas) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/userToBudget`,
            method: "post",
            data: datas,
        });
    }

    //机场静态资源数据查询
    airPortList(datas) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/resource/airPortList`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //获取审核button
    applyButtonQuery(ids) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/applyButton/query`,
            method: "post",
            data: ids,
        });
    }

    //获取审核button
    changeStockDate(ids) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/changeStockDate`,
            method: "post",
            data: ids,
        });
    }

    addResourceTweet(formData) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `${apiType}/platApi/resource/addResourceTweet`,
            method: "post",
            data: formData,
        });
    }

    //快速获取企业信息
    tianyanQuery(keys) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/settle/tianyanQuery`,
            method: "post",
            data: qs.stringify(keys),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //国家模糊列表··
    countryList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/public/countryList`,
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //城市模糊列表··
    cityList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/public/cityList`,
            //url:"http://localhost:9500/wintac-spu-web-test-sx/api/country/cityList",
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //城市热度新增
    addCityHot(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/resource/addCityHot`,
            //url:"http://localhost:9500/wintac-spu-web-test-sx/api/country/cityList",
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    tianyanQueryList(keys) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/settle/tianyanQueryList`,
            method: "post",
            data: qs.stringify(keys),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //更新token
    updateToken(refreshToken) {
        console.log("refreshToken", refreshToken);
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/user/refreshTokenC?refreshToken=${refreshToken}`,
            // url: `http://localhost:9500/wintac-oauth2-web-test-sx/user/refreshTokenC?refreshToken=${refreshToken}`,
            method: "get",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    getResourceType(datas) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/resource/categorySonlist`,
            method: "post",
            data: datas,
        });
    }

    currencySearch(datas) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/resource/currencyList`,
            // url: `http://localhost:9500/wintac-spu-web-test-sx/platApi/resource/currencyList`,
            method: "post",
            data: qs.stringify(datas),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //城市 国家 省份 区域 模糊列表··
    placeList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/place/placeList`,
            method: "post",
            data: obj,
        });
    }

    //城市列表
    cityList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/public/cityList`,
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //车门店搜索
    carQueryStore(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/cb/car/queryStore?cityName=` + obj,
            method: "get",
        });
    }

    //车搜索
    sixtCarList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/cb/car/sixtCarList`,
            method: "post",
            data: obj,
        });
    }

    spotList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/resource/spotList`,
            // url: `http://localhost:9500/wintac-spu-web-test-sx/platApi/resource/spotList`,
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    resourceList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/resource/resourceList`,
            // url: `http://localhost:9500/wintac-spu-web-test-sx/platApi/resource/spotList`,
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //项目询单新增
    projectInquiryAdd(obj) {
        return NewService({
            url: `/customizerWeb/v1/productInquiry/add`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    //整团询单新增
    informationInquiryAdd(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/add`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    //整团询单新增
    orderGrabbingPool(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/orderGrabbingPool`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    //整团询单新增
    grabbOrder(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/grabbOrder`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    //整团询单新增
    transferInquiry(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/transferInquiry`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    //整团询单新增
    grabbingInquiryList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/grabbingInquiryList`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    updateInquiryMaintain(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/updateInquiryMaintain`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/add',
            method: "post",
            data: obj,
        });
    }

    //我的项目询单列表
    projectInquiryList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/projectInquiry/list`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //客户的询单列表
    userProjectInquiryList(obj) {
        let apiType = getType(this.ApiType);
        return NewService({
            // url: `/${apiType}/api/projectInquiry/userList`,
            url:'/customizerWeb/v1/productInquiry/userList',
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //转询加价并发送
    userToBudget(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/projectInquiry/userToBudget`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //我的整团询单列表
    informationInquiryList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/informationInquiry/list`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    addReadNumber(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/projectInquiry/addReadNumber`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: qs.stringify(obj),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }


    //地图模式下的库存列表查询
    stockMapList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/stockMapList`,
            method: "post",
            data: obj,
        });
    }

    //我的项目询单列表点击下面的商品列表
    projectInquiryStockList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/inquiryStockList`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //右侧商品列表
    rightStockList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/stockList`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //快速添加预算商品搜索列表
    fastStockList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/fastStockList`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //商品库存详情
    stockDetail(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/stockDetail`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //右侧商品列表
    climbStockList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/climbStockList`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //爬虫酒店价格详情
    climbStockDetail(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/stock/climbStockDetail`,
            // url:'http://localhost:9500/wintac-inquiry-web-test-sx/api/projectInquiry/list',
            method: "post",
            data: obj,
        });
    }

    //发送验证码
    sendRegisterCode(phoneNumber) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/sms/sendRegisterCode`,
            method: "post",
            data: qs.stringify({phoneNumber: phoneNumber}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //审批项目列表
    approvalProjectList() {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/applyProject/list`,
            method: "post",
        });
    }

    //审批人新增或修改
    hierarchyUpdateOrSave(arr) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/hierarchy/addOrUpdate`,
            method: "post",
            data: arr,
        });
    }

    //审批人删除
    hierarchyDel(id, configId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/hierarchy/del`,
            method: "post",
            data: qs.stringify({id: id, configId: configId}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    //审批人详情
    hierarchyInfo(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/hierarchy/info`,
            method: "post",
            data: qs.stringify({id: id}),
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
        });
    }

    //获取员工列表
    getUserList(datas) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/user/list`,
            method: "post",
            data: datas,
        });
    }

    //注册供应商
    verificationCode(verificationCodeRequest) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/sms/verificationCode`,
            method: "post",
            data: verificationCodeRequest,
        });
    }

    //供应商分页列表（用于委托收款搜索）
    mechanismPageList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/supplier/mechanismPageList`,
            method: "post",
            data: obj,
        });
    }
}

export default Api;
